var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M23.6 20.4c-.6-1.4-.6-1.5-.6-1.6h1-.5l.5-.1s.1.2.5 1.3zM25.6 22.5h-2.2v-1h.7l-.3-.7.9-.4zM20.4 22.5h-3v-1h3zm-5.9 0h-3v-1h3zm-5.9 0h-3v-1h3zM2.6 22.5H.3l1-2.1.9.5-.3.6h.7zM1.608 19.86l.636-1.36.906.424-.636 1.359z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M6.02 18.425 16.2 12.264l.518.855L6.538 19.28zM3.535 16.143l6.01-3.965.55.835-6.01 3.964zM12.802 18.591l6.665-4.052.52.855-6.666 4.052z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M23.3 19.5H3.1c-.3 0-.6-.2-.8-.4-.2-.3-.2-.8-.1-1.1l3-5.3c.1-.3.5-.5.8-.5h14.8c.3 0 .7.2.8.6l.9 1.8c.1.2 0 .5-.2.7-.2.1-.5 0-.7-.2l-.9-1.8H5.9L3 18.6v.2h20.1c.3 0 .5.2.5.5s0 .2-.3.2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M23.7 19.5h-4.5v-5.4h4.5zm-3.5-1h2.5v-3.4h-2.5z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M19.2 15.2c-.1 0-.2 0-.3-.1L3.9 4.4c-.2-.2-.3-.5-.1-.7s.5-.3.7-.1l15 10.7c.2.2.3.5.1.7-.1.1-.2.2-.4.2"
})));
export default SvgYard;